<template>
  <div class="Page">
    <div class="Dv" v-if="!success">Подождите...</div>
    <div class="Dv" v-else>
      Ваша подпись отозвана. Продолжить использование приложения можно по адресу:
      <a
        :href="url"
        target="_blank"
      >{{ url }}</a>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import connect from "@vkontakte/vkui-connect-promise";

export default {
  name: "page-Dropvote",
  data() {
    return {
      url: `https://vk.com/app6945371${
        qs.vk_group_id ? `_-${qs.vk_group_id}` : ""
      }`,
      success: false
    };
  },
  async created() {
    if (window._isMobile) {
      connect.send("VKWebAppSetViewSettings", {
        status_bar_style: "dark",
        action_bar_color: "#fff"
      });
    }

    const {
      data: { response }
    } = await axios.get(`${window.host}/api/dropvote`, {
      params: {}
    });

    console.log(response);

    this.success = true;

    //this.vkAppsInit()
  }
};
</script>

<style scoped>
.Dv {
  padding: 90px 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Dropvote.vue